// components/Login.js

import React, { useState } from "react";
import {
  Box,
  Heading,
  FormControl,
  FormLabel,
  Input,
  Button,
  VStack,
  useToast,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import api from "../api/axios";
import { useAuth } from "../context/AuthContext";
import { setToken, getUser } from "../utils/auth";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const toast = useToast();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log("Sending login data:", { email, password });

      const response = await api.post("/auth/login", { email, password });

      console.log("Login response:", response);

      const token = response.data.token;
      setToken(token);

      // Fetch user data from the server or extract it from the response
      let userData;
      if (response.data.user) {
        userData = response.data.user;
      } else {
        userData = await getUser();
      }
      console.log("Logged in user:", userData);

      // Pass the user data to the login function
      await login(userData);
      navigate("/dashboard");
    } catch (error) {
      console.error("Login error:", error);
      console.error("Error response:", error.response);
      toast({
        title: "Login failed",
        description: error.response?.data?.message || "An error occurred",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Box maxWidth="400px" margin="auto">
      <Heading mb={4}>Login</Heading>
      <form onSubmit={handleSubmit}>
        <VStack spacing={4}>
          <FormControl isRequired>
            <FormLabel>Email</FormLabel>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </FormControl>
          <FormControl isRequired>
            <FormLabel>Password</FormLabel>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </FormControl>
          <Button type="submit" colorScheme="blue" width="100%">
            Login
          </Button>
        </VStack>
      </form>
    </Box>
  );
};

export default Login;
